import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import NeonPiece from '@/components/chess/neon-piece'

interface BrandLogoProps {
    href?: string
    className?: string
}

const BrandLogo: FC<BrandLogoProps> = ({ href = '/', className }): ReactNode => {
    return (
        <Link
            href={href}
            aria-label='Neon Gambit home'
            className={cn('group inline-flex items-center gap-2.5 rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neon-cyan', className)}
        >
            <span className='flex size-9 items-center justify-center rounded-xl border border-neon-pink/50 bg-[#07071a] shadow-[0_0_16px_rgb(255_61_206/0.35)] transition-shadow duration-300 group-hover:shadow-[0_0_24px_rgb(255_61_206/0.6)]'>
                <NeonPiece type='n' strokeWidth={2.2} className='size-7 text-neon-cyan drop-shadow-[0_0_6px_rgb(46_242_255/0.85)]' />
            </span>

            <span className='font-heading text-[15px] font-semibold tracking-[0.16em]'>
                <span className='text-neon-pink glow-text-pink'>NEON</span>
                {' '}
                <span className='text-foreground'>GAMBIT</span>
            </span>
        </Link>
    )
}

export default BrandLogo
